var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.tweetUrl,"target":"_blank","rel":"nofollow"},on:{"click":_vm.fixTweetUrl}},[_c('div',{staticClass:"zzz-birdie-button d-inline-block zzzjpl"},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'twitter']}}),_c('span',{staticClass:"zzz-birdie-button-text ml-2"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }